import { useEffect, useState } from "react";

export const useIsMobile = (breakpoint = 900) => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window === "undefined" ? false : window.innerWidth <= breakpoint
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const check = () => setIsMobile(window.innerWidth <= breakpoint);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);

  return isMobile;
};
